const clientsState = {
    loading: false,
    error: false,
    data: []
}
const clientsReducer = (state = clientsState, action) => {
    switch (action.type) {
        case 'REQUEST_CLIENTS':
            return Object.assign({}, state, {
                loading: true,
                error: false
            })

        case 'REQUEST_CLIENTS_SUCCESS':
            return Object.assign({}, state, {
                data: action.payload,
                error: false,
                loading: false
            })

        case 'REQUEST_CLIENTS_FAIL':
            return Object.assign({}, state, {
                loading: false,
                error: true
            })

        case 'INSERT_CLIENT':
            return Object.assign({}, state, {
                data: [...state.data, action.payload],
            })

        case 'DELETE_CLIENT':
            return Object.assign({}, state, {
                data: state.data.filter(client => client.name !== action.payload)
            })

        case 'UPDATE_CLIENT': {
            const index = state.data.findIndex(client => client.name === action.payload.name)
            let clients = state.data.slice()
            clients[index] = action.payload
            return Object.assign({}, state, {
                data: clients
            })
        }

        default:
            return state
    }
}

export default clientsReducer


// WEBPACK FOOTER //
// ./src/reducers/clientsReducer.js